module.exports = ".highlight{\r\n    background: #42A948; /* green */\r\n  }"